import { Col, Text } from '@opendoor/bricks-next';

import { Logo } from './OpendoorLogo';

interface ILoadingPageWithText {
  text: string;
}

/**
 * FullScreenLoader from Bricks but with text. Growth to add to Bricks if
 * untreated room condition experiment is successful.
 */
export const LoadingPageWithText = (props: ILoadingPageWithText) => (
  <Col
    width="100%"
    height="100%"
    justifyContent="center"
    alignItems="center"
    p="$8x"
    $largerThanXS={{ p: '$12x' }}
    $largerThanMD={{ p: '$16x' }}
    backgroundColor="$backgroundAccentBrand"
    data-testid="full-screen-loader"
  >
    <Col className="full-screen-loader-pulse">
      <Logo variant="secondary" height={100} color="$contentInversePrimary" />
    </Col>
    <Text tag="p" typography="$labelLarge" pt="$10x" color="$contentInversePrimary">
      {props.text}
    </Text>
  </Col>
);
